import React from 'react'
import { observer } from 'mobx-react'
import { IoIosCloseCircle as CloseIcon } from 'react-icons/io'
import isArray from 'lodash/isArray'
import {
  Button,
  Col,
  Row,
  Card,
  Badge,
  OverlayTrigger,
  Form,
} from 'react-bootstrap'
import debounce from 'lodash/debounce'
import { Link } from 'react-router-dom'
import { enableStorePickup, VARIANT_NODES, APPConfig } from 'config/appConfig'
import {
  getLocalStorage,
  application,
  getLocaleString,
  checkEnableButton,
  currencyFormat,
  checkMysiteOrPersonalOffer,
  getLiveEventStatus,
  i18nTranslate,
  isToShowOverrideSubscription,
  convertToBoolean,
  isEligibleToShowPVCVSV,
  isFeatureEnabled,
  stripCurrencySymbol,
} from 'src/utils'
import {
  Quantity,
  AccordionBlock,
  storePickupState,
  SubscriptionDropDown,
  toastState,
  ImageComponent,
  SingleProductSubscriptionModal,
  overlayState,
} from 'src/views/components'
import { SingleLineAddress } from '../SingleLineAddress'
import { ProductPrice } from '../../ProductComponents/ProductSkuDetails/ProductPrice'
import { PreOrderTime } from '../../ProductComponents/PreOrderTime'
import { observable, action } from 'mobx'
import {
  customerContainer,
  cartContainer,
  nuskinSubscriptionContainer,
  storeContainer,
} from 'src/models'
import {
  dateFormatDeps,
  productDeps,
  isSubscriptionFlagEnabled,
} from 'src/deps'
import { CartScanCardWithInfo } from 'src/views/components/SubscriptionComponents/CartScanCardWithInfo'
import { MdShoppingCart as ShoppingCartIcon } from 'react-icons/md'
import ViewCartRefreshIcon from 'src/views/components/Icons/ViewCartRefreshIcon'
import { alertMessageKeys } from '../fixture'
import { isEquinoxMysite } from 'src/utils/mySiteUtils'
import ProductStatusBadge from 'src/views/components/CatalogViews/ProductCard/ProductStatusBadge'
import './styles.scss'

@observer
class CheckoutProductBlock extends React.Component {
  @observable subscriptionParameters = {}
  @observable isSubscribeCheckboxChecked = false
  @observable checkBoxLabel = i18nTranslate('cart.subscribe', 'Subscribe')
  @observable isToShowViewCartModal = false
  enableLiveEvent = getLiveEventStatus()
  constructor(props, context) {
    super()
    this.context = context
    this.contextName = 'productData'
    this.handleChange = this.handleChange.bind(this)
  }

  // uncommenting the below lifecyle method to check Auto authorize login for mysite & personal offer
  // async componentDidMount() {
  //   this.signInUrl = await signInwithRedirect(true)
  // }

  componentWillMount() {
    const { cartItemId = '' } = this.props
    this.id = `subscribe-checkbox-${cartItemId}`
  }

  @action
  subscriptionBtnClick = async (props = {}, enableToastMessage = true) => {
    let isSubscription = props.isSubscription || false
    this.isSubscribeCheckboxChecked = !this.isSubscribeCheckboxChecked
    const isBundle = productDeps.isBundleData(props)
    const {
      productId = '',
      skuId = '',
      categoryId = '',
      scanQualifiedCount = 0,
      quantity = 0,
      frequency = 1,
    } = props
    let skus = [
      {
        skuId: skuId,
        productId: productId,
        type: 'DEFAULT',
      },
    ]
    if (isBundle) {
      skus = productDeps.getBundleData(props)
    }
    if (!isSubscription) {
      const postParameters = [
        {
          quantity: quantity,
          skus: skus,
          isSubscription: true,
          subscription: {
            frequencyPeriod: frequency,
            frequencyType: 'MONTHS',
          },
          properties: {
            category: categoryId,
            scanQualifiedCount: scanQualifiedCount,
          },
          frequencyPeriod: frequency,
          frequencyType: 'MONTHS',
          category: categoryId,
          isSubscriptionPreference: customerContainer.isSubscriptionPreference,
          productId: productId,
          skuId: isBundle ? productId : skuId,
        },
      ]
      const subscriptionParams = {
        id: this.props.cartItemId,
        subscriptionData: {
          isSubscription: true,
          subscription: { frequencyPeriod: frequency, frequencyType: 'MONTHS' },
          quantity: quantity,
        },
        type: 'subscription',
      }
      this.subscriptionParameters = postParameters
      this.props.handleSubscribeCheckboxClick(
        subscriptionParams,
        enableToastMessage
      )
    } else {
      const subscriptionParams = {
        id: this.props.cartItemId,
        subscriptionData: {
          isSubscription: false,
        },
        type: 'oneTime',
      }
      this.props.handleSubscribeCheckboxClick(
        subscriptionParams,
        enableToastMessage
      )
    }
    this.isToShowViewCartModal = false
  }

  handleUpdateSubscription = async modalData => {
    if (customerContainer.isRegisterUser) {
      const frequency = modalData?.frequency || 1
      const quantity = modalData?.quantity || 1
      const SubscribedProductSkuId = modalData?.product?.skuId || ''
      const items = cartContainer?.cartResponse?.items || []

      // getting deep copy of cart items, so that on API fail, cart items are not modified
      const cartItems = JSON.parse(JSON.stringify(items))

      let subscriptionItems = cartItems?.filter(item => {
        let skuId = item?.skus?.[0]?.skuId || ''
        return (
          !item?.properties?.hasOwnProperty('isGiftItem') &&
          skuId === SubscribedProductSkuId
        )
      })

      subscriptionItems[0].isSubscription = true
      subscriptionItems[0].quantity = quantity
      subscriptionItems[0].subscription = {
        frequencyPeriod: frequency,
        frequencyType: 'MONTHS',
      }

      const response =
        await nuskinSubscriptionContainer.updateSubscription(subscriptionItems)
      if (nuskinSubscriptionContainer.isSuccessResponse(response)) {
        this.toggleSubscribeModal()
      }
    } else {
      this.subscriptionBtnClick(modalData)
    }
  }

  cartAddTrigger = async (props = {}) => {
    const { productId = '', skuId = '', quantity = 0 } = props
    const cartArray = [
      {
        productId: productId,
        quantity: quantity,
        skuId: skuId,
      },
    ]
    if (cartArray) {
      cartContainer.toShowToast = false
      const response = await cartContainer.addToCart({
        cartArray,
      })
      return response
    }
  }

  // subscriptionAddTrigger = async () => {
  //   const response = await subscriptionContainer.addToSubscription(
  //     this.subscriptionParameters
  //   )
  //   console.log(customerContainer,response,'response')
  //   let subscriptionMessage = subscriptionContainer.subscriptionMessage || ''
  //   if (customerContainer.isSuccessResponse(response)) {
  //     // await cartContainer.viewCart()
  //     // toastState.setToastMessage(
  //     //   i18nTranslate('subscription.success', 'Added Subscriptions Successfully')
  //     // )
  //     // this.checkBoxLabel = 'Subscribed'
  //     if (customerContainer.isSuccessResponse(response)) {
  //       // await cartContainer.viewCart()
  //       // toastState.setToastMessage(
  //       //   i18nTranslate('subscription.success', 'Added Subscription Successfully')
  //       // )
  //     } else {
  //       const errorMessage =
  //         response?.message ||
  //         i18nTranslate(
  //           'signup.failure',
  //           'Sorry, we are unable to create your account. Please try again.'
  //         )
  //       toastState.setToastMessage(errorMessage, false)
  //     }

  //     if (
  //       customerContainer.isSuccessResponse(response) &&
  //       !customerContainer.isSubscriptionPreference
  //     ) {
  //       await cartContainer.viewCart()
  //       toastState.setToastMessage(subscriptionMessage, true)
  //     }
  //   } else {
  //     this.props?.handleDeleteCartItem(this.props)
  //     if (response.code === 'YLUSSB015') {
  //       toastState.setToastMessage(response.message, false, 6000)
  //     }
  //   }
  // }

  handleChange = (product = {}) => {
    this.subscriptionBtnClick(product)
  }

  toggleSubscribeModal = () => {
    this.isToShowViewCartModal = !this.isToShowViewCartModal
  }

  handleSubscribeCheck = props => {
    let isSubscription = props.isSubscription || false
    const clickedProductSkuId =
      props?.skuId ||
      props.product?.skuId ||
      props.product?.productId ||
      props.productId ||
      ''

    const sameProductBlockCount =
      nuskinSubscriptionContainer.getClickedProductCountInCart(
        clickedProductSkuId
      )

    const isToShowNewDesign = isSubscriptionFlagEnabled() || false

    if (customerContainer.isRegisterUser) {
      const userHasExistingSubscriptions =
        nuskinSubscriptionContainer.isUserSubscribedBefore()

      if (userHasExistingSubscriptions && !isToShowNewDesign) {
        const isProductAlreadySubscribed =
          nuskinSubscriptionContainer.isAlreadyASubscribedProduct(props)
        // CX121-4082 - showing already subscribed product (disabled) in modal
        if (isProductAlreadySubscribed) {
          if (isSubscription) {
            this.subscriptionBtnClick(props)
          } else {
            nuskinSubscriptionContainer.clickedProductSkuId =
              clickedProductSkuId
            nuskinSubscriptionContainer.isToShowDisabledModal = true
          }
        } else {
          if (!isSubscription) {
            sameProductBlockCount.length > 1
              ? nuskinSubscriptionContainer.handleAlreadySubscribedToast()
              : this.toggleSubscribeModal()
          } else {
            sameProductBlockCount.length > 1
              ? nuskinSubscriptionContainer.handleAlreadyOTPToast()
              : this.subscriptionBtnClick(props)
          }
        }
      } else {
        // CX121-3761 - user does not have any subscriptions currently
        if (!isSubscription) {
          sameProductBlockCount.length > 1
            ? nuskinSubscriptionContainer.handleAlreadySubscribedToast()
            : this.subscriptionBtnClick(props)
        } else {
          sameProductBlockCount.length > 1
            ? nuskinSubscriptionContainer.handleAlreadyOTPToast()
            : this.subscriptionBtnClick(props)
        }
      }
    } else {
      //guest user case
      if (!isSubscription) {
        sameProductBlockCount.length > 1
          ? nuskinSubscriptionContainer.handleAlreadySubscribedToast()
          : isToShowNewDesign
            ? this.subscriptionBtnClick(props)
            : this.toggleSubscribeModal()
      } else {
        sameProductBlockCount.length > 1
          ? nuskinSubscriptionContainer.handleAlreadyOTPToast()
          : this.subscriptionBtnClick(props)
      }
    }
  }

  quantityDecrementCheck = async (count = 0, itemId = 0) => {
    await nuskinSubscriptionContainer.subscriptionItemDecrementCheck(
      count,
      itemId
    )
  }

  renderSubscriptionModalInViewCart = props => {
    let isUserSubscribedBefore =
      nuskinSubscriptionContainer.isUserSubscribedBefore()
    return (
      <SingleProductSubscriptionModal
        type="cart"
        // don't change this "type" property,
        // it is passed and used in subscriptionquantity and scancard related components
        product={props}
        isSignedUser={customerContainer.isRegisterUser}
        onUserSubscribe={modalData => {
          this.handleUpdateSubscription(modalData)
        }}
        isSubscribedBefore={isUserSubscribedBefore}
        show={this.isToShowViewCartModal}
        handleQuantityChange={props.handleCartQuantityChange}
        decrementCheck={this.quantityDecrementCheck}
        onHide={this.toggleSubscribeModal}
      />
    )
  }

  hasImportedDevice() {
    const { bundleProducts = {}, transactionPrice = {} } = this.props
    if (bundleProducts?.products?.length > 0) {
      // Bundle case
      return bundleProducts.products.some(
        product =>
          product?.transactionPrice?.skuProperties?.importedDevice === 'true'
      )
    } else {
      // Single product case
      return transactionPrice?.skuProperties?.importedDevice === 'true'
    }
  }

  renderProductDetail = (props = {}) => {
    let {
      productUrl = '',
      imageURL = '',
      productName = '',
      productDescription = '',
      skuId = '',
      productId = '',
      skuQuantity = 0,
      isFromBundle = false,
      transactionPrice = {},
      isSubscription = false,
      isSaveForLater = false,
      isNativeApp = false,
      availableChannels = '',
      bundleProductSlug = '',
      bundleProductVariant = '',
      productStatus = '',
      errorCode = '',
      bundleProducts = {},
      isReviewSection = false,
      isMultipleAdressActive = false,
      isPBomProduct = false,
    } = props

    isPBomProduct = this.props.productionBom

    const localStore = getLocalStorage('storeProducts') || {}
    const storeProductsInCookie =
      localStore !== null && localStore !== '' ? localStore : {}
    const storeProductState =
      storePickupState.storePickupProducts?.hasOwnProperty(skuId)
    const storeProductCookie =
      storeProductsInCookie.hasOwnProperty(skuId) || false
    const isProdAvailInStore = storeProductState || storeProductCookie
    const inventoryProperties =
      this.props?.transactionPrice?.inventoryProperties || {}
    const isPreOrder = inventoryProperties?.preOrdered || false

    const isBackOrderBadgeEnabled = convertToBoolean(
      APPConfig?.getAppConfig()?.enableBackOrderBadgeForCartAndCheckout
    )

    // Create a minimal product object for ProductStatusBadge
    const productForStatusBadge = {
      sku: [{ inventoryProperties }],
    }

    const slugVariant = this?.props?.skuSlug || this?.props?.skuId || ''
    let navigateURL = ''
    const variantLabel = this?.props?.variantLabel || bundleProductVariant || ''

    if (variantLabel) {
      if (isFromBundle) {
        navigateURL = `${productUrl}?variant=${bundleProductSlug}`
      } else {
        navigateURL = `${productUrl}?variant=${slugVariant}`
      }
    } else {
      navigateURL = `${productUrl}`
    }
    if (isNativeApp) {
      // Disabling product link for products in VERA & STELA app
      productUrl = '#'
    }
    const isSubscriptionPreference = customerContainer.isSubscriptionPreference
    const isEnableSubscriptionCheckbox = checkEnableButton(
      availableChannels,
      'subscription'
    )
    // let shoppingContext = getLocalStorage('shoppingContext') || {}
    // let contextText = shoppingContext?.context || ''
    const contextText = isEquinoxMysite() ? '' : checkMysiteOrPersonalOffer()
    const isAvailOnlyInSubscription =
      this.props?.availableChannels == 'subscription'
    const isDiscontinuedProduct =
      productStatus?.toLowerCase() === 'discontinued' ||
      errorCode === 'EOSKUPS002'
    const isToDisableSubscribeCheckbox =
      isAvailOnlyInSubscription || isDiscontinuedProduct
    const isBundle = bundleProducts?.products?.length || 0
    const isToShowNewDesign = isSubscriptionFlagEnabled() || false
    const skuLabel = isToShowNewDesign
      ? i18nTranslate('viewcart.skuIdLabel', 'SKU')
      : i18nTranslate('cart.itemId', 'SKU #')
    const isSubscriptionOverridePage = isToShowOverrideSubscription()
    const addOnCount = bundleProducts?.optionalCount || ''
    const isImportedDevice = this.hasImportedDevice()
    const enableBundleItemQuantity = isFeatureEnabled(
      'enableBundleSubItemTotalText'
    )
    const totalQty = bundleProducts?.products?.reduce(
      (total, product) => total + (product?.skuQuantity || 0),
      0
    )
    const enableLoyaltyPoints = storeContainer.getLoyaltyPointsConfig() || false
    return (
      <Row noGutters>
        <div className="p-0 mb-3 cart-product-img">
          {contextText == '' && !isSubscriptionOverridePage ? (
            <Link to={navigateURL}>
              {/* <Card.Img
              data-testid="qa-product-image"
              src={imageURL || imagePlaceholder}
              onError={e => (
                (e.target.onerror = null), (e.target.src = imagePlaceholder)
              )}
              alt={productName}
            /> */}
              <ImageComponent
                testId="qa-product-image"
                src={imageURL}
                alt={productName}
                height={'100px'}
                width={'100px'}
              />
            </Link>
          ) : (
            <ImageComponent
              testId="qa-product-image"
              src={imageURL}
              alt={productName}
              height={'100px'}
              width={'100px'}
            />
          )}
        </div>
        <Col className="pl-2 pr-2 view-cart-product-details">
          <Row noGutters>
            {isSubscription &&
              isToShowNewDesign &&
              !isBundle &&
              !isSubscriptionOverridePage &&
              this.renderSubscriptionItemLabel()}
            <Col lg={12} className="p-0 view-cart-product-name">
              {contextText == '' && !isSubscriptionOverridePage ? (
                <Link to={navigateURL} className="text-dark">
                  <Card.Title data-testid="qa-product-name">
                    <h4>{productName}</h4>
                  </Card.Title>
                </Link>
              ) : (
                <Card.Title data-testid="qa-product-name">
                  <h4>{productName}</h4>
                </Card.Title>
              )}
            </Col>
            {productDescription && (
              <Col lg={12} className="p-0">
                <Card.Subtitle
                  className="text-truncate cart-product-subtitle"
                  data-testid="qa-product-description">
                  {productDescription}
                </Card.Subtitle>
              </Col>
            )}
            {isPreOrder === true && (
              <Col lg={12}>
                <Badge variant="info" className="checkout-pre-order-badge">
                  {i18nTranslate('checkout.preOrder', 'Preorder')}
                </Badge>
              </Col>
            )}
            {isBackOrderBadgeEnabled && (
              <ProductStatusBadge
                product={productForStatusBadge}
                size="small"
              />
            )}
            <div className="col-12">
              <div className="p-0 view-cart-sku-details">
                <Card.Text data-testid="qa-product-number" tabIndex={0}>
                  <span className=" checkout-product-num checkout-product-details paragraph-m">
                    {skuLabel}
                    {':'}
                  </span>

                  {skuId?.length > 15 ? (
                    <OverlayTrigger
                      placement="bottom-start"
                      delay={{ show: 100, hide: 250 }}
                      overlay={
                        <div className="checkout-skuId-tooltip">{skuId}</div>
                      }>
                      <span className="ml-1 checkout-skuId d-inline-block text-truncate w-50">
                        {skuId}
                      </span>
                    </OverlayTrigger>
                  ) : (
                    <span className="ml-1 paragraph-m view-cart-sku-id">
                      {skuId}
                    </span>
                  )}
                </Card.Text>
              </div>
              {VARIANT_NODES?.map(skuKey => {
                const skuValue = props[skuKey]
                if (skuValue) {
                  return (
                    <div
                      className="p-0 view-cart-variants"
                      data-testid={`qa-product-${skuKey}`}>
                      {getLocaleString()[skuKey]}: {skuValue}
                    </div>
                  )
                }
                return <></>
              })}
            </div>

            {isSubscription &&
              !isToShowNewDesign &&
              !isSubscriptionOverridePage &&
              this.renderFrequency()}
            {isFromBundle && (
              <Col lg={12} className="bundle-quantity-wrapper">
                <span className="bundle-quantity-label">
                  {isToShowNewDesign
                    ? i18nTranslate(
                        'bundle.fixedQuantityTitleV2',
                        'Item Quantity',
                        {
                          nameSpace: 'ssr-resource',
                        }
                      )
                    : i18nTranslate('quantity', 'Quantity')}
                </span>
                <span className="bundle-quantity-colon">:</span>
                <span className="bundle-quantity-value ml-1">
                  {skuQuantity}
                </span>
              </Col>
            )}
            {!isFromBundle && enableStorePickup && (
              <Col
                lg={12}
                className="d-none flex-wrap p-0"
                data-testid="qa-product-fis">
                <span
                  className={`store-name-cart ${
                    isProdAvailInStore ? 'font-weight-bold' : ''
                  }`}>
                  {isProdAvailInStore
                    ? storeProductsInCookie[skuId]
                      ? storeProductsInCookie[skuId]
                      : storePickupState?.storePickupProducts[skuId]
                        ? storePickupState?.storePickupProducts[skuId]
                        : i18nTranslate('bopis.pick', 'Pick It in Store:', {
                            nameSpace: 'ssr-resource',
                          })
                    : i18nTranslate('bopis.pick', 'Pick It in Store:', {
                        nameSpace: 'ssr-resource',
                      })}
                </span>
                <span
                  className="store-pickup-label-cart ml-2"
                  onClick={() =>
                    storePickupState.toggleStorePickupModal(skuId, productId)
                  }>
                  <b>
                    {isProdAvailInStore
                      ? i18nTranslate('bopis.change', 'Change', {
                          nameSpace: 'ssr-resource',
                        })
                      : i18nTranslate('bopis.selectStore', 'Select a Store', {
                          nameSpace: 'ssr-resource',
                        })}
                  </b>
                </span>
              </Col>
            )}
            <PreOrderTime {...transactionPrice.skuProperties} />
          </Row>
          {isEnableSubscriptionCheckbox &&
            !isFromBundle &&
            !isSaveForLater &&
            this.enableLiveEvent !== 'true' &&
            !isSubscriptionOverridePage &&
            !isImportedDevice && (
              <Row noGutters className="cart-item-details-row">
                <Col>
                  {!convertToBoolean(
                    APPConfig?.getAppConfig()?.hideSubscription
                  ) && (
                    <div
                      className={`view-cart-subscribe ${
                        isToDisableSubscribeCheckbox
                          ? 'disable-sub-checkbox'
                          : ''
                      }`}>
                      <Form.Check
                        disabled={isToDisableSubscribeCheckbox}
                        type="checkbox"
                        className="pl-0 py-2"
                        label={this.checkBoxLabel}
                        id={this.id}
                        checked={isSubscription}
                        onChange={() => {
                          this.handleSubscribeCheck(this.props)
                        }}
                        onKeyPress={() => {
                          this.handleSubscribeCheck(this.props)
                        }}
                        data-testid="qa-subscription-checkbox"
                      />
                    </div>
                  )}
                  {isSubscription &&
                    isToShowNewDesign &&
                    !enableLoyaltyPoints &&
                    this.renderFrequency(isToShowNewDesign)}
                </Col>
              </Row>
            )}
          <Row noGutters className="cart-item-details-row">
            {this.renderPrice(this.props, isFromBundle, isToShowNewDesign)}
          </Row>
          {!isFromBundle && (
            <Row
              noGutters
              className={`cart-item-details-row
                ${
                  isSaveForLater
                    ? 'justify-content-between'
                    : isToShowNewDesign
                      ? 'cart-product-block'
                      : 'cart-product-block'
                }`}>
              {!isSaveForLater && this.renderQuantity(isToShowNewDesign)}
            </Row>
          )}
          {/* <!-- Render Sub Products --> */}
          {isBundle && !isPBomProduct ? (
            <>
              <div className="align-items-center cart-item-details-row view-cart-header-section">
                <AccordionBlock
                  className="mr-auto py-0 mt-0 subproducts-collapse"
                  textClass="text-primary"
                  title={
                    <>
                      <span className="" data-testid="qa-count">
                        {bundleProducts?.optionalCount || ''}
                        {i18nTranslate('cart.adonitem', 'add-on')}
                        &nbsp;{bundleProducts?.mandatoryCount || ''}
                        {i18nTranslate('cart.cartItems', 'items')},&nbsp;
                      </span>
                      {addOnCount > 0 && (
                        <span className="" data-testid="qa-count">
                          {bundleProducts?.optionalCount || ''}
                          {i18nTranslate('cart.adonitem', 'add-on')}
                          &nbsp;
                        </span>
                      )}
                      {i18nTranslate(
                        'checkout.productItem.viewItems',
                        'view items'
                      )}
                      {enableBundleItemQuantity && (
                        <span className="accordion-bundle-item-quantity-total">
                          {` (${i18nTranslate('checkout.productItem.totalQty', 'Total Qty')}: ${totalQty})`}
                        </span>
                      )}
                    </>
                  }
                  dataTestId="qa-cart-view"
                  isOutsideAccordion={true}>
                  {bundleProducts?.products?.map(this.renderBundleProducts)}
                </AccordionBlock>
              </div>
            </>
          ) : (
            <React.Fragment />
          )}
        </Col>
      </Row>
    )
  }

  renderPromoDetail = (props = {}) => {
    const { promotionDetails = [], freeGiftProductsList = [] } = this.props
    let skus = []
    if (freeGiftProductsList?.length > 0) {
      for (let i = 0; i < freeGiftProductsList?.length; i++) {
        skus.push(freeGiftProductsList?.[i]?.skus?.[0]?.skuId)
      }
    }
    // Filter out promotions with zero total discount value
    const filteredPromotions =
      promotionDetails?.filter(promo => promo?.totalValue !== 0) || []
    return (
      <>
        {filteredPromotions?.length > 0 &&
          filteredPromotions?.map((list, index) => {
            const NotOutOfStock = list?.isGift
              ? skus?.includes(list?.skuId)
              : true
            const displayMessage = list?.displayMessage || ''
            const message = list?.message || displayMessage || ''
            return (
              <>
                {NotOutOfStock && (
                  <span
                    className="product-promotion justify-content-start mt-2 mb-2"
                    key={index}>
                    {message}
                  </span>
                )}
              </>
            )
          })}
      </>
    )
  }

  renderPrice = (
    props = {},
    isBundleProduct = false,
    isToShowNewDesign = false
  ) => {
    const { promotionDetails = [] } = this.props
    const isToShowNewPriceStyling = isToShowNewDesign || false

    return (
      <Col className="cart-price-wrapper justify-content-md-center justify-content-lg-center p-0 m-md-0 m-lg-0">
        {/* Hide price and promotion section for individual items of Bundle and Kit */}
        {!isBundleProduct && (
          <>
            <ProductPrice
              isToShowNewPriceStyling={isToShowNewPriceStyling}
              {...this.props}
            />
            {promotionDetails?.length > 0 && (
              <div className="checkout-product-promotion-wrapper d-flex flex-column">
                {this.renderPromoDetail(props)}
              </div>
            )}
          </>
        )}
      </Col>
    )
  }
  replaceCurrencySymbol = (price = '') => {
    return stripCurrencySymbol(price)
  }

  getPrice = (custompriceValue = 0, options = {}) => {
    const formattedPrice = currencyFormat({
      price: custompriceValue,
      ...options,
    })
    const formattedCustomPrice = this.replaceCurrencySymbol(formattedPrice)
    return formattedCustomPrice
  }

  renderTotalPrice = (props = {}) => {
    const { isSaveForLater = false, totalPrice = '', grandTotal = '' } = props
    const CVPriceDis =
      this.props?.TotalVal?.priceFacets?.CV?.CVAfterDiscount || 0

    const PVPriceDis =
      this.props?.TotalVal?.priceFacets?.PV?.PVAfterDiscount || 0

    const CVTotalPrice = this.getPrice(CVPriceDis, { isPVCV: true })
    const PVTotalPrice = this.getPrice(PVPriceDis, { isPVCV: true })
    const discountVal = this.props?.TotalVal?.discount || 0
    const isDiscount = discountVal != 0 ? true : false
    const textColor = isDiscount ? 'text-dark' : ''

    const priceFreeValue = this.props?.TotalVal?.priceAfterDiscount || 0
    const finalPrice =
      grandTotal == '' && priceFreeValue == 0 ? '$0.00' : grandTotal
    const { isReviewSection = false } = this.props
    const localvalue = getLocalStorage('accountType') || ''
    const reviewSectionClass =
      isReviewSection && isDiscount ? 'font-weight-bold text-danger' : ''
    const userRole = customerContainer?.profileResponse?.userrole || ''
    const isToShowNewDesign = isSubscriptionFlagEnabled() || false
    const isToShowPVCVSV = isEligibleToShowPVCVSV({ accountType: localvalue })
    return (
      <>
        {!isSaveForLater && (
          <Col
            data-testid="qa-product-total"
            className={`${textColor} pl-1 p-0 cart-total-price-wrapper mb-4`}>
            {totalPrice && (
              <>
                {finalPrice && (
                  <Row noGutters className="mx-0">
                    <Col
                      lg={12}
                      className="mt-1 d-flex  p-0  totalValueFlexEnd view-cart-total-value">
                      <p
                        className={`pl-sm-1 pl-xs-1 mb-0 d-sm-block d-xs-block ${
                          this.enableLiveEvent !== 'true' && isToShowNewDesign
                            ? 'hide-total-label'
                            : ''
                        }`}>
                        {i18nTranslate('cart.total', 'Total')} :
                      </p>
                      <span
                        className={`${reviewSectionClass} pl-1 font-weight-bold`}
                        aria-live="polite">
                        {finalPrice != '' ? finalPrice : totalPrice}
                      </span>
                    </Col>
                    {PVTotalPrice && isToShowPVCVSV && (
                      <Col
                        lg={12}
                        className="mt-2 d-flex justify-content-end view-cart-sv-value">
                        <p className="pv-cart-values mb-0">
                          {i18nTranslate('cart.itemTotalSV', 'SV')} :
                          <span className="pl-1">{PVTotalPrice}</span>
                        </p>
                      </Col>
                    )}
                    {CVTotalPrice && isToShowPVCVSV && (
                      <>
                        {userRole !== 'ROLE_ACCOUNT_BUYER_ADMIN' && (
                          <Col lg={12} className="mt-2 view-cart-cv-value">
                            <p className="pv-cart-values mb-0">
                              {i18nTranslate('cart.itemTotalCV', 'CV')} :
                              <span className="pl-1">{CVTotalPrice}</span>
                            </p>
                          </Col>
                        )}
                      </>
                    )}
                  </Row>
                )}
              </>
            )}
          </Col>
        )}
      </>
    )
  }

  renderInventoryResponse = () => {
    const bundleResponse = this.props?.bundleProducts?.products || {}
    const items = cartContainer?.cartResponse.items || []
    let item =
      isArray(items) &&
      items?.filter(item => item?.itemId == this.props?.cartItemId)
    let errorCode = item?.[0]?.errorCode || ''
    let inventoryStatusView = ''
    let customFontClass = ''
    let flagInventory = ''
    const isBackOrderBadgeEnabled = convertToBoolean(
      APPConfig?.getAppConfig()?.enableBackOrderBadgeForCartAndCheckout
    )

    const errorMessages = {
      EOSKUPS004: i18nTranslate(
        'bundle.replacement',
        'This is a replacement product and not available for purchase',
        {
          nameSpace: 'ssr-resource',
        }
      ),
      EOSKUPS001: i18nTranslate(
        'bundle.preview',
        'Preview product and will be launched soon',
        {
          nameSpace: 'ssr-resource',
        }
      ),
      EOSKUPS003: i18nTranslate(
        'bundle.stopped',
        'This product is temporarily stopped',
        {
          nameSpace: 'ssr-resource',
        }
      ),
      EOSKUPS002: i18nTranslate(
        'bundle.discontinuedV2Message',
        'Discontinued - This product or promotion has been discontinued',
        {
          nameSpace: 'ssr-resource',
        }
      ),
      EOSKUPS000: i18nTranslate(
        'bundle.itemNotAvailable',
        'Item is not available for purchase',
        {
          nameSpace: 'ssr-resource',
        }
      ),
      EOKIT000001: i18nTranslate(
        'product.kitNotAvailable',
        'This kit is no longer available, please select a different kit and try again',
        {
          nameSpace: 'ssr-resource',
        }
      ),
      EOCA0000013: i18nTranslate('cart.outOfStock', 'Out of Stock'),
    }
    inventoryStatusView =
      errorMessages[errorCode] || item?.[0]?.errorMessage || ''
    flagInventory = errorCode ? true : false
    if (inventoryStatusView === '') {
      const { productionBom = false, transactionPrice = {} } = this.props
      const {
        inventoryProperties = {},
        skuProperties = {},
        type = '',
      } = transactionPrice

      const isPBomProduct = productDeps.isPbomProduct({
        type: type,
        properties: skuProperties,
      })

      if (bundleResponse?.length >= 1) {
        if (isPBomProduct) {
          //Checking for header level inventory validation for pbom Product
          const pbomInventoryCheck = this.checkForBackOrderDate(
            inventoryProperties,
            isBackOrderBadgeEnabled
          )
          inventoryStatusView = pbomInventoryCheck?.inventoryStatusView || ''
          flagInventory = pbomInventoryCheck?.flagInventory || false
          customFontClass = pbomInventoryCheck?.customFontClass || ''
        } else {
          //Checking sku level inventory for special products(bundle,kit)
          const inventoryBundle =
            bundleResponse &&
            bundleResponse?.map(
              inventory => inventory?.transactionPrice?.inventoryProperties
            )
          let inventoryStatusViewbundle = []
          let expectedBackOrderDate = ''
          inventoryBundle?.forEach(newitem => {
            if (
              (newitem?.available === false &&
                newitem?.backOrdered === false) ||
              (newitem?.available === false && newitem?.backOrdered === '')
            ) {
              inventoryStatusViewbundle.push(false) // in-stock/out-of-stock check
            } else {
              if (newitem?.backOrdered === true) {
                inventoryStatusViewbundle.push(true) // backordered check
                expectedBackOrderDate =
                  newitem?.expectedBackOrderAvailabilityDate || ''
              }
            }
            if (inventoryStatusViewbundle?.includes(false)) {
              flagInventory = true
              inventoryStatusView = i18nTranslate(
                'cart.outOfStock',
                'Out of Stock'
              )
            } else {
              if (inventoryStatusViewbundle?.includes(true)) {
                // Delegate to checkForBackOrderDate so the badge-suppression rule lives in one place;
                // keep this path's original local-time formatting and blank fallback (no generic label).
                const bundleInventoryCheck = this.checkForBackOrderDate(
                  {
                    available: true,
                    backOrdered: true,
                    expectedBackOrderAvailabilityDate: expectedBackOrderDate,
                  },
                  isBackOrderBadgeEnabled,
                  { useUTC: false, fallbackToGenericLabel: false }
                )
                inventoryStatusView =
                  bundleInventoryCheck?.inventoryStatusView || ''
                flagInventory = bundleInventoryCheck?.flagInventory || false
                customFontClass = bundleInventoryCheck?.customFontClass || ''
              }
            }
          })
        }
      } else {
        //Normal sku inventory validation
        const inventoryProperties =
          this.props?.transactionPrice?.inventoryProperties || {}
        const normalSkuInventory = this.checkForBackOrderDate(
          inventoryProperties,
          isBackOrderBadgeEnabled
        )
        inventoryStatusView = normalSkuInventory?.inventoryStatusView || ''
        flagInventory = normalSkuInventory?.flagInventory || false
        customFontClass = normalSkuInventory?.customFontClass || ''
      }
    }
    let fontWeightForStatusView =
      customFontClass === 'backorder-bold'
        ? 'font-weight-bold'
        : 'font-weight-normal'
    if (inventoryStatusView.includes('FSSAI')) {
      toastState.setToastMessage(inventoryStatusView, false, 8000)
    }
    return (
      <div>
        <p
          className={`${
            !flagInventory
              ? 'availability-text mt-2 text-success font-weight-bold p-0 mb-0'
              : `availability-text mt-2 text-danger ${fontWeightForStatusView} p-0 mb-0`
          }`}>
          {errorCode === 'EOCA0000012'
            ? alertMessageKeys(
                'Product/SKU got removed from catalog, kindly remove this item to proceed.'
              )
            : alertMessageKeys(inventoryStatusView.trim())}
        </p>
      </div>
    )
  }

  checkForBackOrderDate = (
    inventoryProperties = {},
    isBackOrderBadgeEnabled = false,
    { useUTC = true, fallbackToGenericLabel = true } = {}
  ) => {
    let inventoryAvailable = inventoryProperties?.available ?? ''
    let inventoryBackodered = inventoryProperties?.backOrdered ?? ''
    const { expectedBackOrderAvailabilityDate = '' } = inventoryProperties
    let inventoryStatusView = ''
    let flagInventory = false
    let customFontClass = ''
    if (
      (inventoryAvailable === false && inventoryBackodered === false) ||
      (inventoryAvailable === false && inventoryBackodered === null)
    ) {
      inventoryStatusView = i18nTranslate(
        'item.notAvailable',
        'Item currently not available'
      )
      flagInventory = true
    } else if (
      (inventoryAvailable === false && inventoryBackodered === true) ||
      (inventoryAvailable === true && inventoryBackodered === true)
    ) {
      if (isBackOrderBadgeEnabled) {
        return {
          flagInventory: false,
          inventoryStatusView: '',
          customFontClass: '',
        }
      }
      flagInventory = true
      let backorderTime = ''
      if (expectedBackOrderAvailabilityDate?.toString().length <= 10) {
        backorderTime = expectedBackOrderAvailabilityDate + '000'
      } else {
        backorderTime = expectedBackOrderAvailabilityDate
      }
      if (backorderTime && expectedBackOrderAvailabilityDate !== 0) {
        backorderTime = Number(backorderTime)
        /**
         * @Note
         * EQH-94 - Back order date shows up incorrectly on EQ
         * Changed to UTC Format, as per BackEnd Team Elangovan's Request
         */
        let {
          date = '',
          month = '',
          year = '',
        } = dateFormatDeps.convertTimeStampToDate(backorderTime, useUTC)
        const formatedDateAsPerLocale =
          dateFormatDeps.getFormattedDateAsPerLocale(date, month, year)
        inventoryStatusView =
          i18nTranslate('backordered', 'Ships by', {
            nameSpace: 'ssr-resource',
          }) +
          ' ' +
          formatedDateAsPerLocale
        customFontClass = 'backorder-bold'
      } else if (fallbackToGenericLabel) {
        inventoryStatusView = i18nTranslate(
          'orderSearch.backOrdered',
          'BackOrdered'
        )
      }
    } else {
      flagInventory = false
    }
    return { flagInventory, inventoryStatusView, customFontClass }
  }

  decrementCheck = (count = 0, step = 0) => {
    let quantityDecrement = true
    const cartResponse = cartContainer?.cartResponse?.items || []
    let item = cartResponse?.filter(
      item => item?.itemId === this.props?.cartItemId
    )
    let properties = item[0]?.properties || {}
    let scanArr = []
    try {
      scanArr = properties?.scanCardDetails
        ? JSON.parse(properties?.scanCardDetails)
        : []
    } catch (e) {
      console.log(e)
    }
    // let scanCount = item[0]?.skus[0]?.skuProperties?.scanQualifiedCount || 0
    let scanCount = 0
    item[0]?.skus?.map(data => {
      scanCount =
        parseInt(scanCount) +
        (data?.skuProperties?.scanQualifiedCount
          ? parseInt(data?.skuProperties?.scanQualifiedCount)
          : 0)
    })
    let scanQualifiedCount = (count - step) * scanCount
    if (scanArr?.length > scanQualifiedCount) {
      quantityDecrement = false
      let x = scanArr?.length - scanQualifiedCount
      let plsMsg = i18nTranslate('scan.please', 'Please remove')
      let manualMsg = i18nTranslate(
        'scan.manual',
        ' scancard(s) manually to proceed further'
      )
      let msg = plsMsg + x + manualMsg
      toastState.setToastMessage(msg)
    }

    return quantityDecrement
  }

  renderFrequency = (isToShowNewDesign = false) => {
    let {
      subscription = {},
      handleSubscriptionChange = function () {},
      cartItemId = 0,
      quantity = 0,
    } = this.props
    const frequencyPeriod = subscription?.frequencyPeriod || ''
    const frequencyType = subscription?.frequencyType || ''

    return (
      <Col lg={12} className="view-cart-frequency-wrapper">
        <SubscriptionDropDown
          frequencyPeriod={frequencyPeriod}
          frequencyType={frequencyType}
          itemId={cartItemId}
          quantity={quantity}
          handleSubscriptionChange={handleSubscriptionChange}
          isToShowNewFrequencyStyling={isToShowNewDesign}
          isFromViewCartPage={true}
        />
      </Col>
    )
  }

  renderQuantity = (isToShowNewDesign = false) => {
    const maxLimit = APPConfig?.getAppConfig()?.cartMaxLimit || 99
    const {
      quantity = 0,
      maxCartItemLimit = maxLimit,
      cartItemId = 0,
      handleCartQuantityChange = function () {},
      enableQuantityEdit = true,
    } = this.props
    const productId = this.props?.productId
    const productQualificationResponse =
      customerContainer?.qualificationResponse?.qualification?.filter(p => {
        return p?.productId === productId
      })
    const maxQuantity =
      productQualificationResponse?.[0]?.quantity > maxLimit
        ? maxLimit
        : productQualificationResponse?.[0]?.quantity
    const isToShowNewQuantityField = isToShowNewDesign || false

    return (
      <Col className="cart-quantity-wrapper view-cart-quantity-wrapper p-0">
        <Row
          noGutters
          className="justify-content-md-left justify-content-lg-left quantity-field-wrapper">
          <div className="quantity-txt">
            {this.enableLiveEvent !== 'true'
              ? i18nTranslate('product.quantity', 'Quantity', {
                  nameSpace: 'ssr-resource',
                })
              : i18nTranslate('product.qty', 'Qty')}
            :
          </div>
          {enableQuantityEdit ? (
            <Quantity
              onQuantityChange={debounce(async (count, cbk) => {
                overlayState.showLoader()
                const response = await handleCartQuantityChange(
                  count,
                  cartItemId
                )
                if (cbk) {
                  cbk(response)
                }
              }, 500)}
              decrementCheck={this.decrementCheck}
              currentPage="cart"
              resetQtyOnFailure={true}
              defaultValue={quantity}
              maxValue={maxQuantity}
              isV2QuantityStyle={isToShowNewQuantityField}
            />
          ) : (
            <>
              {application.isMobile && (
                <span>
                  {i18nTranslate('product.quantity', 'Quantity', {
                    nameSpace: 'ssr-resource',
                  })}
                  :{' '}
                </span>
              )}
              {quantity}
            </>
          )}
        </Row>
      </Col>
    )
  }

  renderButtons = () => {
    const { handleDeleteCartItem = function () {}, productName = '' } =
      this.props
    return (
      <Row noGutters className="cart-product-item-btn-wrapper">
        <Col className="mb-2 px-2 view-cart-delete-icon-wrapper">
          <Button
            className="w-100 cart-remove-button d-flex justify-content-end align-items-end"
            onClick={() => handleDeleteCartItem(this.props)}
            variant="outline-primary"
            data-testid="qa-product-remove">
            <CloseIcon
              className="close-icon mr-1"
              aria-label={`${i18nTranslate(
                'cart.remove',
                'Remove'
              )} ${productName}`}
            />
            {i18nTranslate('cart.remove', 'Remove')}
          </Button>
        </Col>
      </Row>
    )
  }

  renderBundleProducts = (product = {}) => {
    const isSubscriptionOverridePage = isToShowOverrideSubscription()
    return (
      <div className="BundleItem">
        <div>
          {this.renderProductDetail({ ...product, isFromBundle: true })}
        </div>
        {this.renderPrice(product, true)}
        {/* CX121-4017 - BA action item, Storefront UI:enable the scan card option at KIT/Bundle header instead of component level.
        <Col className="col-12 bundleScanCardBtn">
          {!isSubscriptionOverridePage && this.renderScanCardBtn(product, true)}
        </Col> */}
        {this.renderTotalPrice(product)}
      </div>
    )
  }

  renderItemLevelAddress = () => {
    const { address = {} } = this.props
    if (
      address &&
      typeof address === 'object' &&
      Object.keys(address)?.length > 0
    ) {
      return (
        <Row className="d-flex flex-column p-0 text-capitalize w-100">
          <h4>
            {i18nTranslate('checkout.shippingAddress', 'Shipping Address')}
          </h4>
          <SingleLineAddress address={address} />
        </Row>
      )
    }
  }

  renderScanCardBtn = (product = {}, isBundle = false) => {
    let productDetails = isBundle ? product : this.props
    let isSubscription = isBundle
      ? product?.transactionPrice?.skuProperties?.issubscription
      : this.props?.isSubscription
    let scanQualifiedCount = 0

    if (isBundle) {
      isSubscription = productDetails?.[0]?.isSubscription
      productDetails?.[0]?.skus?.forEach(newitem => {
        const scanCount = parseInt(
          newitem?.skuProperties?.scanQualifiedCount || 0
        )
        scanQualifiedCount = scanCount + scanQualifiedCount
      })
    } else {
      scanQualifiedCount =
        this.props?.transactionPrice?.skuProperties?.scanQualifiedCount || 0
    }
    let propsToPass = isBundle
      ? { ...productDetails, ...this.props }
      : this.props
    return (
      isSubscription &&
      scanQualifiedCount > 0 && (
        <CartScanCardWithInfo
          page="cart"
          isPopupForMovingCartProductsToDashboard={false}
          bundleInfo={{ isBundle, bundleScanCount: scanQualifiedCount }}
          {...propsToPass}
        />
      )
    )
  }

  renderSubscriptionItemLabel = () => {
    return (
      <div className="subscription-item-label" tabIndex={0}>
        <span className="subscription-icon">
          <ViewCartRefreshIcon
            className="view-cart-refresh-icon"
            width="9"
            height="9"
            fillColor="#252525"
          />
        </span>
        <span className="subscription-item-label-text">
          {i18nTranslate('viewcart.subscriptionItemLabel', 'Subscription item')}
        </span>
      </div>
    )
  }

  render() {
    const {
      isCheckout = false,
      isReviewSection = false,
      isSaveForLater = false,
      bundleProducts = {},
      className = '',
      isMultipleAdressActive = false,
      enableButtons = true,
      isSubscription = false,
      handleSaveForLater = function () {},
    } = this.props
    const isBundle = bundleProducts?.products?.length || 0
    const isToShowButtons = isReviewSection ? false : enableButtons

    const items = cartContainer?.cartResponse.items || []
    let item =
      isArray(items) &&
      items?.filter(item => item?.itemId == this.props?.cartItemId)
    let errorCode = item?.[0]?.errorCode || ''
    const dynamicClassName = isCheckout
      ? 'checkout-container'
      : 'cart-container'
    const isError =
      isCheckout && errorCode === 'EOCA0000012'
        ? 'checkout-container-error'
        : dynamicClassName
    const addOnCount = bundleProducts?.optionalCount || ''
    const userRole = customerContainer?.profileResponse.userrole || ''
    const isToShowNewDesign = isSubscriptionFlagEnabled() || false
    const type = cartContainer.getSpecialProductType(item?.[0]?.skus || [])
    const isPBomProduct = productDeps.isPbomProduct({
      type: type,
      properties: { productionBom: item?.[0]?.properties?.productionBom },
    })
    const isSubscriptionOverridePage = isToShowOverrideSubscription()
    const scanCardInCart = isFeatureEnabled('scanCardInCart')
    return (
      <>
        <Card
          className={`cart-product-wrapper view-cart-item-wrapper p-2  ${isError} ${className} w-100`}
          data-testid="qa-cart-product">
          {isSubscription &&
            isToShowNewDesign &&
            isBundle > 0 &&
            !isSubscriptionOverridePage &&
            this.renderSubscriptionItemLabel()}
          {/* {isToShowNewDesign &&
            isToShowButtons === true &&
            this.renderButtons()} */}
          <Row
            noGutters
            className={`cart-product-details ${
              isSaveForLater ? 'justify-content-between w-100' : ''
            }`}>
            <Col
              className="p-0 cart-card-info col-9"
              data-testid="qa-products-container">
              {this.renderProductDetail({ errorCode, ...this.props })}
              <p
                className="availability-text ml-2 text-success font-weight-bold"
                data-testid="qa-product-availability">
                {this.renderInventoryResponse()}
              </p>
              {scanCardInCart &&
                !isSubscriptionOverridePage &&
                this.renderScanCardBtn(item, isBundle)}
            </Col>
            <Col className="col-3">
              <div
                className={`mt-2 align-items-end justify-content-center view-cart-total-section ${
                  !application.isMobile && !isToShowNewDesign ? 'd-flex' : ''
                } `}>
                {this.renderTotalPrice(this.props)}
              </div>
            </Col>
            <div className="col cart-item-bottom-buttons cart-remove-button-right">
              <button
                data-testid="qa-product-remove"
                className="btn btn-link"
                onClick={() => this.props.handleDeleteCartItem(this.props)}>
                <>
                  <CloseIcon
                    className="close-icon mr-1"
                    aria-label={`${i18nTranslate(
                      'cart.remove',
                      'Remove'
                    )} ${this.props.productName}`}
                  />
                  {i18nTranslate('cart.remove', 'Remove')}
                </>
              </button>
              {!isBundle &&
                userRole?.length > 0 &&
                this.enableLiveEvent !== 'true' &&
                !isSubscriptionOverridePage && (
                  <Button
                    className="cart-product-button btn btn-link"
                    onClick={() =>
                      handleSaveForLater({
                        ...this.props,
                        source: 'main-cart',
                      })
                    }
                    variant="link"
                    data-testid={
                      isSaveForLater
                        ? 'qa-product-movetocart'
                        : 'qa-saveforlater'
                    }>
                    {!isSaveForLater ? (
                      i18nTranslate('cart.saveforlater', 'Save For Later')
                    ) : (
                      <>
                        <ShoppingCartIcon
                          className="close-icon mr-1"
                          aria-label={i18nTranslate(
                            'icons.moveToCart',
                            'move to cart icon',
                            {
                              nameSpace: 'ssr-resource',
                            }
                          )}
                        />
                        {i18nTranslate('cart.movetocart', 'Move To Cart')}
                      </>
                    )}
                  </Button>
                )}
            </div>
          </Row>
        </Card>
        {this.isToShowViewCartModal &&
          this.renderSubscriptionModalInViewCart(this.props)}
      </>
    )
  }
}

export { CheckoutProductBlock }
export default CheckoutProductBlock
